import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CartOutlets, PromotionLocation } from '@spartacus/cart/base/root';
import { Order, OrderFacade, OrderHistoryFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { CustomCheckoutService } from '../../../../core/src/checkout/facade/custom-checkout.service';

@Component({
  selector: 'cx-order-confirmation-items',
  templateUrl: './custom-order-confirmation-items.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomOrderConfirmationItemsComponent implements OnInit, OnDestroy {
  readonly cartOutlets = CartOutlets;
  promotionLocation: PromotionLocation = PromotionLocation.Checkout;
  order$: Observable<Order | undefined>;
  displayOrderbyCode: boolean;

  constructor(
    protected orderFacade: OrderFacade,
    protected checkoutService: CustomCheckoutService,
    private activatedRoute: ActivatedRoute,
    private orderHistoryFacade: OrderHistoryFacade
  ) {
    this.displayOrderbyCode = !!this.activatedRoute.snapshot.url[1]?.path;
  }

  ngOnInit(): void {
    if (this.displayOrderbyCode) {
      this.order$ = this.orderHistoryFacade.getOrderDetails();
    } else {
      this.order$ = this.orderFacade.getOrderDetails();
    }
  }

  ngOnDestroy(): void {
    if (this.displayOrderbyCode) {
      this.orderHistoryFacade.clearOrderDetails();
    } else {
      this.orderFacade.clearPlacedOrder();
    }
  }
}
